import React from 'react'
import {VerticalTimeline, VerticalTimelineElement} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Title from "./Title";
import {FaFirstOrder} from "react-icons/fa";
import Chip from '@material-ui/core/Chip';

export default function TimePath(props) {
    return (
        <div className='timePath container text-center' style={{margin:'0 auto'}}>
            <Title title='Work Experience'/>
            <div className="container">
                <VerticalTimeline className='lrPadding'>
                    {
                        props.jobs.map(item => {
                            return(

                                <VerticalTimelineElement 
                                    key={item.id}
                                    className="vertical-timeline-element--work"
                                    contentStyle={{}}
                                    iconStyle={{
                                    background: 'rgb(255 217 188)',
                                    color: '#fff'
                                }}icon={<img className='companyLogo' alt='IMG' src={item.images.file.url}/>}>
                                    <h2 className="vertical-timeline-element-subtitle">{item.companyName}</h2>
                                    <h5 className="vertical-timeline-element-title">{item.title} Developer</h5>
                                    <h6>
                                        {
                                            item.workPeriod
                                        }
                                        {
                                             item.stillWorkingThere ? ' - Till Now' : ' To '+ item.wokringEnd
                                        }
                                        <br/>
                                        {item.workType}
                                        </h6>
                                    <p className='vertical-timeline-element-desc'>{item.desc}</p>
                                    <ul className='worklist'>
                                        {
                                            item.worklist.map((item,index) => {
                                                return <li key={index}> <FaFirstOrder/> <p> {item}</p> </li>
                                            })
                                        }
                                    </ul>
                                    <div className="text-container technologies">
                                        
                                        <h5>Technologies used</h5>
                                        {
                                            item.skills.map((skill, index) => {
                                                return (<Chip color="secondary" size="small" key={index} label={skill}/>)
                                            })
                                        }
                                    </div>
                                    <div className="text-container curved-block">
                                        <h5>Deliverd Projects</h5>
                                        {
                                            item.projects.map((skill, index) => {
                                                return (<Chip color="secondary" size="small" key={index} label={skill}/>)
                                            })
                                        }
                                    </div>
                                </VerticalTimelineElement>
                            )
                        })
                    }
                </VerticalTimeline> 
            </div>
        </div>
    )
}
